/*
 * 平台管理-CSG
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';

export default {
    path: 'platform',
    name: 'BusinessPlatForm',
    component: EmptyRouterAlive,
    meta: {
      title: '平台管理',
    },
    children: [
       // csg User端
    {
      path: 'online',
      name: 'BusinessChannelOnlineCsg',
      component: EmptyRouter,
      redirect: 'csg/csgIndex',
      meta: {
        title: '店铺管理',
        isCache: true,
      },
      children: [
        {
          path: 'csg/csgIndex',
          name: 'BusinessChannelOnlineCsg',
          component: () => import('@/views/center-business/channel/online/csg/csgIndex.vue'),
          meta: {
            title: '店铺管理',
            isCache: true,
          },
        },
        /** 分配物流  */
        {
          path: 'flowdistribution/indexCsg',
          name: 'BusinessChannelOnlineFlowDistributionCsg',
          component: () => import('@/views/center-business/channel/online/flowdistribution/indexCsg.vue'),
          meta: { title: '分配物流', isCache: true },
          hidden: true,
        },
        /** 分配物流 end */
        /** 按钮权限start */
        {
          path: '',
          name: 'BusinessChannelOnlineCsgList_Add',
          meta: { title: '创建网店', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlineCsgList_Edit',
          meta: { title: '编辑网店' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlineCsgList_Delete',
          meta: { title: '删除网店' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlineCsgList_Status',
          meta: { title: '启用/禁用' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlineCsgList_Log',
          meta: { title: '日志' },
          hidden: true,
        },
      ],
    },
    // csg Admin端
    {
      path: 'online',
      name: 'BusinessChannelOnlineCsgAdmin',
      component: EmptyRouter,
      redirect: 'csg/csgAdminIndex',
      meta: {
        title: '网店管理',
        isCache: true,
      },
      children: [
        {
          path: 'csg/csgAdminIndex',
          name: 'BusinessChannelOnlineCsgAdmin',
          component: () => import('@/views/center-business/channel/online/csg/csgAdminIndex.vue'),
          meta: {
            title: '网店管理',
            isCache: true,
          },
        },
        /** 分配物流  */
        {
          path: 'flowdistribution/indexCsgAdmin',
          name: 'BusinessChannelOnlineFlowDistributionCsgAdmin',
          component: () => import('@/views/center-business/channel/online/flowdistribution/indexCsgAdmin.vue'),
          meta: { title: '分配物流', isCache: true },
          hidden: true,
        },
        /** 分配物流 end */
        /** 按钮权限start */
        {
          path: '',
          name: 'BusinessChannelOnlineCsgAdminList_Add',
          meta: { title: '创建网店', isCache: true },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlineCsgAdminList_Edit',
          meta: { title: '编辑网店' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlineCsgAdminList_Delete',
          meta: { title: '删除网店' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlineCsgAdminList_Status',
          meta: { title: '启用/禁用' },
          hidden: true,
        },
        {
          path: '',
          name: 'BusinessChannelOnlineCsgAdminList_Log',
          meta: { title: '日志' },
          hidden: true,
        },
      ],
    },
    // 外部平台订单 External platform orders
    {
      path: 'ExternalOrders',
      name: 'BusinessChannelExternalPlatformOrders',
      component: EmptyRouter,
      redirect: 'index',
      meta: {
        title: '外部平台订单',
        isCache: true,
      },
      children: [
        {
          path: 'index',
          name: 'BusinessChannelExternalPlatformOrders',
          component: () => import('@/views/center-business/channel/ExternalOrders/index.vue'),
          meta: {
            title: '外部平台订单',
            isCache: true,
          },
        },
      ]
    },
    // EDI订单平台 EDI tools
    {
      path: 'EDI',
      name: 'BusinessChannelEDIOrders',
      component: EmptyRouter,
      redirect: 'EDI/index',
      meta: {
        title: 'EDI订单平台',
        isCache: true,
      },
      children: [
        {
          path: 'index',
          name: 'BusinessChannelEDIOrders',
          component: () => import('@/views/center-business/channel/EDI/index.vue'),
          meta: {
            title: 'EDI订单平台',
            isCache: true,
          },
        },
      ]
    },
    ],
  };
